var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68867 6.31133C7.31703 5.68297 8.33579 5.68297 8.96414 6.31133L12.3773 9.72453L15.7906 6.31133C16.4189 5.68297 17.4377 5.68297 18.066 6.31133C18.6944 6.93968 18.6944 7.95844 18.066 8.5868L14.6528 12L18.066 15.4132C18.6944 16.0416 18.6944 17.0603 18.066 17.6887C17.4377 18.317 16.4189 18.317 15.7906 17.6887L12.3773 14.2755L8.96414 17.6887C8.33579 18.317 7.31703 18.317 6.68867 17.6887C6.06032 17.0603 6.06032 16.0416 6.68867 15.4132L10.1019 12L6.68867 8.5868C6.06032 7.95844 6.06032 6.93968 6.68867 6.31133Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.79af44dea7acd29fe3a299719f6d3a08.svg";
export { ForwardRef as ReactComponent };